export default __webpack_public_path__ + "static/media/plan-a-media-group-adrienne-wilkinson.b34418c5.png";